<template>
<div class="dropdown" :class="{
  'is-hoverable': isHoverable,
  'is-active': isActive,
  'is-right': isRight
  }">
  <div class="dropdown-trigger">
    <slot></slot>
  </div>
  <div class="dropdown-menu">
    <div class="dropdown-content">
      <slot name="dropdown-content"></slot>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    isRight: {
      type: Boolean,
      default: false
    },
    isHoverable: {
      type: Boolean,
      default: false
    },
    isActive: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    active: {
      get () { return this.isActive },
      set (value) { this.$emit('update:isActive', value) }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';
a.dropdown-item:hover {
  background-color: rgba($brand-primary, 0.2);
  text-decoration: none;
}
.dropdown-trigger {
  width: 100%;
}
.dropdown-menu {
  width: 100%;
}
.dropdown-content {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/general/dropdown.vue